import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Auth
export const registerAuthService = (data) => {
  return http.post(`${base_url}/auth/register`, data);
};
export const logInAuthService = (data) => {
  return http.post(`${base_url}/auth/login`, data);
};
export const forgetPassAuthService = (data) => {
  return http.post(`${base_url}/auth/forgot-password`, data);
};
export const verifyPhoneNumberOTPAuthService = (data) => {
  return http.patch(`${base_url}/auth/phone-number/otp/verify`, data);
};
// End Auth

// Start Info
export const editInfoUserService = (data) => {
  return http.put(`${base_url}/user/info`, data);
};
export const getInfoUserService = () => {
  return http.get(`${base_url}/user/info`);
};
// End Info

// Start Transaction
export const getTransactionsUserService = (params) => {
  return http.get(`${base_url}/user/transactions`, { params });
};
// End Transaction

// Start Ticket
export const createTicketUserService = (data) => {
  return http.post(`${base_url}/user/ticket`, data);
};
export const getTicketsUserService = (params) => {
  return http.get(`${base_url}/user/tickets`, { params });
};
export const getTicketUserService = (id) => {
  return http.get(`${base_url}/user/ticket/${id}`);
};
export const sendTicketMessageUserService = (data) => {
  return http.put(`${base_url}/user/ticket/${data.id}`, data);
};
export const closeTicketUserService = (id) => {
  return http.patch(`${base_url}/user/ticket/${id}`);
};
export const deleteTicketUserService = (id) => {
  return http.delete(`${base_url}/user/ticket/${id}`);
};
// End Ticket

// Start Change Password
export const changePasswordAuthService = (data) => {
  return http.post(`${base_url}/user/change-password`, data);
};
// End Change Password

// Start Upload
export const uploadUserService = (data, params) => {
  return http.post(`${base_url}/user/upload`, data, {
    params,
    headers: { "Content-Type": "multipart/form-data" },
  });
};
// End Upload

// Start Meta
export const getMetaUserService = () => {
  return http.get(`${base_url}/user/meta`);
};
// End Meta

// Start Snapp Trip
export const getCitiesSnappTripService = () => {
  return http.get(`${base_url}/user/snapp-trip/cities`);
};
export const getCitySnappTripService = (id) => {
  return http.get(`${base_url}/user/snapp-trip/cities/${id}`);
};
export const getCityHotelsSnappTripService = (params) => {
  return http.get(`${base_url}/user/snapp-trip/cities/${params.id}/hotels`, {
    params,
  });
};
export const searchCitiesAndHotelsSnappTripService = (params) => {
  return http.get(`${base_url}/user/snapp-trip/search`, {
    params,
  });
};
export const getHotelSnappTripService = (params) => {
  return http.get(`${base_url}/user/snapp-trip/hotels/${params.id}`, {
    params,
  });
};
export const getHotelRoomsSnappTripService = (params) => {
  return http.get(`${base_url}/user/snapp-trip/hotels/${params.id}/rooms`, {
    params,
  });
};
export const getHotelRacksSnappTripService = (params) => {
  return http.get(`${base_url}/user/snapp-trip/hotels/${params.id}/racks`, {
    params,
  });
};
export const getRoomRacksSnappTripService = (params) => {
  return http.get(
    `${base_url}/user/snapp-trip/hotels/${params.id}/rooms/${params.roomID}/racks`,
    {
      params,
    }
  );
};
export const createBookSnappTripService = (data) => {
  return http.post(`${base_url}/user/snapp-trip/booking`, data);
};
export const updateBookSnappTripService = (data) => {
  return http.put(
    `${base_url}/user/snapp-trip/booking/${data.reservation_code}`,
    data
  );
};
export const confirmBookSnappTripService = (data) => {
  return http.post(
    `${base_url}/user/snapp-trip/booking/${data.reservation_code}/confirm`,
    data
  );
};
// End Snapp Trip

// Start Passenger
export const createPassengerUserService = (data) => {
  return http.post(`${base_url}/user/passenger`, data);
};
export const getPassengersUserService = (params) => {
  return http.get(`${base_url}/user/passengers`, { params });
};
export const editPassengerUserService = (data) => {
  return http.put(`${base_url}/user/passenger/${data.id}`, data);
};
export const deletePassengerUserService = (id) => {
  return http.delete(`${base_url}/user/passenger/${id}`);
};
// End Passenger

// Start Hotel Order
export const getHotelOrdersUserService = (params) => {
  return http.get(`${base_url}/user/hotel/order`, { params });
};
// End Hotel Order

// Start Fly Order
export const getFlyOrdersUserService = (params) => {
  return http.get(`${base_url}/user/fly/order`, { params });
};
// End Fly Order

// Start OTP
export const sendPhoneNumberOTPUserService = (data) => {
  return http.post(`${base_url}/user/phone-number/otp/send`, data);
};
export const verifyPhoneNumberOTPUserService = (data) => {
  return http.patch(`${base_url}/user/phone-number/otp/verify`, data);
};
export const sendEmailOTPUserService = (data) => {
  return http.post(`${base_url}/user/email/otp/send`, data);
};
export const verifyEmailOTPUserService = (data) => {
  return http.patch(`${base_url}/user/email/otp/verify`, data);
};
// End OTP

// Start Charter 724
export const getAirportListCharter724UserService = () => {
  return http.get(`${base_url}/user/charter-724/airport-list`);
};
export const getAvailable15DaysCharter724UserService = (data) => {
  return http.post(`${base_url}/user/charter-724/available-15-days`, data);
};
export const getAvailableCharter724UserService = (data) => {
  return http.post(`${base_url}/user/charter-724/available`, data);
};
export const getCaptchaCharter724UserService = (data) => {
  return http.post(`${base_url}/user/charter-724/captcha`, data);
};
export const reservationCharter724UserService = (data) => {
  return http.post(`${base_url}/user/charter-724/reservation`, data);
};
export const payAndBuyTicketCharter724UserService = (data) => {
  return http.post(`${base_url}/user/charter-724/pay-and-buy-ticket`, data);
};
export const checkTransactionCharter724UserService = (data) => {
  return http.post(`${base_url}/user/charter-724/check-transaction`, data);
};
export const checkPenaltiCharter724UserService = (data) => {
  return http.post(`${base_url}/user/charter-724/check-penalti`, data);
};
export const cancelTicketCharter724UserService = (data) => {
  return http.post(`${base_url}/user/charter-724/cancel-ticket`, data);
};
// End Charter 724

// Start Reception Info
export const getReceptionInfosUserService = (params) => {
  return http.get(`${base_url}/user/reception-infos`, { params });
};
export const getReceptionInfoUserService = (id) => {
  return http.get(`${base_url}/user/reception-info/${id}`);
};
// End Reception Info

// Start Reception Order
export const getReceptionOrdersUserService = (params) => {
  return http.get(`${base_url}/user/reception-orders`, { params });
};
export const createReceptionOrderUserService = (data) => {
  return http.post(`${base_url}/user/reception-order/${data.id}`, data);
};
export const changeReceptionOrderStatusUserService = (data) => {
  return http.patch(`${base_url}/user/reception-order/${data.id}/status`, data);
};
// End Reception Order

// Start Shop Order
export const getShopOrdersUserService = (params) => {
  return http.get(`${base_url}/user/shop-orders`, { params });
};
// End Shop Order

// Start Notification
export const getNotificationsUserService = (params) => {
  return http.get(`${base_url}/user/notification`, { params });
};
export const deleteAllNotificationUserService = () => {
  return http.delete(`${base_url}/user/notification`);
};
export const deleteNotificationUserService = (id) => {
  return http.delete(`${base_url}/user/notification/${id}`);
};
export const readNotificationUserService = (id) => {
  return http.patch(`${base_url}/user/notification/${id}/read`);
};
export const readAllNotificationUserService = () => {
  return http.patch(`${base_url}/user/notification/read`);
};
// End Notification
